import { Maybe } from 'maybeasy';
import { Error } from '../../ErrorHandling';
import { Link, Resource } from '../../Resource/Types';
import { StringOption } from '../../components/Options/Types';

export interface GroupsOptions {
  status: StringOption[];
  loginActivities: StringOption[];
  participant: Maybe<StringOption>;
}

export type GroupsOptionsResource = Resource<GroupsOptions>;

interface Waiting {
  kind: 'waiting';
}

interface Loading {
  kind: 'loading';
  links: ReadonlyArray<Link>;
}

interface Ready {
  kind: 'ready';
  resource: GroupsOptionsResource;
}

export const waiting = (): Waiting => ({
  kind: 'waiting',
});

export const loading = (links: ReadonlyArray<Link>): Loading => ({
  kind: 'loading',
  links,
});

export const ready = (resource: GroupsOptionsResource): Ready => ({
  kind: 'ready',
  resource,
});

export type State = Waiting | Loading | Ready | Error;
